import { ROUTE_PERMISSIONS } from '@shared/permissions';
import { lazyWithReload } from '@shared/react/lazyWithReload';
import { PermissionGuard, ValidUuidGuard } from '@shared/router';
import { Route } from 'react-router-dom';

import {
  checkoutsDetailRoute,
  checkoutsPath,
  mobileAppPath,
  payLinksCreatePath,
  payLinksDetailRoute,
  payLinksPath,
  paymentDetailRoute,
  paymentsSection,
  payoutDetailRoute,
  payoutsPath,
  quickPayCreatePath,
  quickPayDetailRoute,
  quickPayPath,
  recurringPaymentCreatePath,
  recurringPaymentDetailRoute,
  recurringPaymentSection,
} from './urls';

const PaylinksDetail = lazyWithReload(() =>
  import('./pages/PaylinksDetail').then((m) => ({ default: m.PaylinksDetail }))
);
const PaylinksLanding = lazyWithReload(() =>
  import('./pages/PaylinksLanding').then((m) => ({ default: m.PaylinksLanding }))
);
const PaymentCreate = lazyWithReload(() =>
  import('./pages/PaymentCreate').then((m) => ({ default: m.PaymentCreate }))
);
const PaymentsLanding = lazyWithReload(() =>
  import('./pages/PaymentsLanding').then((m) => ({ default: m.PaymentsLanding }))
);
const CheckoutLanding = lazyWithReload(() =>
  import('./pages/CheckoutLanding').then((m) => ({ default: m.CheckoutLanding }))
);
const CheckoutDetail = lazyWithReload(() =>
  import('./pages/CheckoutDetail').then((m) => ({ default: m.CheckoutDetail }))
);
const PayoutListLanding = lazyWithReload(() =>
  import('./pages/PayoutList').then((m) => ({ default: m.PayoutList }))
);
const PayoutDetail = lazyWithReload(() =>
  import('./pages/PayoutDetail').then((m) => ({ default: m.PayoutDetail }))
);
const PaymentDetail = lazyWithReload(() =>
  import('./pages/PaymentDetail').then((m) => ({ default: m.PaymentDetail }))
);
const RecurringPaymentList = lazyWithReload(() =>
  import('@components/modules/recurringPayment/pages/RecurringPaymentList').then((m) => ({
    default: m.RecurringPaymentList,
  }))
);

const RecurringPaymentDetail = lazyWithReload(() =>
  import('@components/modules/recurringPayment/pages/RecurringPaymentDetail').then((m) => ({
    default: m.RecurringPaymentDetail,
  }))
);

const RecurringPaymentCreate = lazyWithReload(() =>
  import('@components/modules/recurringPayment/pages/RecurringPaymentCreate').then((m) => ({
    default: m.RecurringPaymentCreate,
  }))
);

const QuickPayLanding = lazyWithReload(() =>
  import('./pages/QuickPayLanding').then((m) => ({ default: m.QuickPayLanding }))
);
const QuickPayDetail = lazyWithReload(() =>
  import('./pages/QuickPayDetail').then((m) => ({ default: m.QuickPayDetail }))
);
const QuickPayCreate = lazyWithReload(() =>
  import('./pages/QuickPayCreate').then((m) => ({ default: m.QuickPayCreate }))
);

export const PaymentRoutes = (
  <>
    <Route
      path={paymentDetailRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.payments}>
          <ValidUuidGuard paramName="paymentId">
            <PaymentDetail />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
    <Route
      path={paymentsSection}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.payments}>
          <PaymentsLanding />
        </PermissionGuard>
      }
    />
    <Route
      path={payLinksPath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.payLinksDetail}>
          <PaylinksLanding />
        </PermissionGuard>
      }
    />
    <Route
      path={quickPayPath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.quickPay}>
          <QuickPayLanding />
        </PermissionGuard>
      }
    />
    <Route
      path={quickPayCreatePath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.quickPayCreate}>
          <QuickPayCreate />
        </PermissionGuard>
      }
    />
    <Route
      path={quickPayDetailRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.quickPayDetail}>
          <QuickPayDetail />
        </PermissionGuard>
      }
    />
    <Route
      path={payLinksCreatePath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.payLinksCreate}>
          <PaymentCreate />
        </PermissionGuard>
      }
    />
    <Route
      path={payLinksDetailRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.payLinksDetail}>
          <ValidUuidGuard paramName="invoiceId">
            <PaylinksDetail />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
    <Route
      path={recurringPaymentSection}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.recurringPayment}>
          <RecurringPaymentList />
        </PermissionGuard>
      }
    />
    <Route
      path={recurringPaymentCreatePath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.recurringPayment}>
          <RecurringPaymentCreate />
        </PermissionGuard>
      }
    />
    <Route
      path={recurringPaymentDetailRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.recurringPaymentDetail}>
          <ValidUuidGuard paramName="id">
            <RecurringPaymentDetail />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
    <Route
      path={checkoutsPath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.checkouts}>
          <CheckoutLanding />
        </PermissionGuard>
      }
    />
    <Route
      path={checkoutsDetailRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.checkouts}>
          <ValidUuidGuard paramName="id">
            <CheckoutDetail />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
    <Route
      path={payoutsPath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.payments}>
          <PayoutListLanding />
        </PermissionGuard>
      }
    />
    <Route
      path={payoutDetailRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.payments}>
          <ValidUuidGuard paramName="id">
            <PayoutDetail />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
    <Route
      path={mobileAppPath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.payments}>
          <h1>Mobile App</h1>
        </PermissionGuard>
      }
    />
  </>
);

export default PaymentRoutes;
